import { createContext, useContext, type Dispatch, type SetStateAction } from 'react'
import type { CartPanelItem, useCartPanelItems } from '../hooks/useCartPanelItems'

export type CartProjection = ReturnType<typeof useCartPanelItems> & {
  updateCartInclusion: (item: CartPanelItem) => Promise<void>
  setRefreshFailedFlightKeys: Dispatch<SetStateAction<Record<string, boolean>>>
}

export const CartProjectionContext = createContext<CartProjection | undefined>(undefined)

export function useCartProjection(): CartProjection {
  const value = useContext(CartProjectionContext)
  if (!value) throw new Error('useCartProjection must be used within TripChatRuntime')
  return value
}
